<script>
	import { link } from 'svelte-routing';
	import * as FileSaver from "file-saver";
	import * as XLSX from "xlsx";
	import Modal from "./../../components/Modal/Modal.svelte";
	import Strapi from "strapi-sdk-javascript";
	import MainContent from "../../components/MainContent.svelte";
	import SideNavBar from "../../components/SideNavBar.svelte";
	import { onMount } from "svelte";
	import jwt_decode from "jwt-decode";
	import { strapi_api } from "../../utils/config";
	import { each } from "svelte/internal";
import Link from 'svelte-routing/src/Link.svelte';

	let show = false;
	let current_version;
	let versions_list = [];
	let book_title = null;
	let book_form = null;
	let chapters = [];
	let chapterName = null;
	let isRenderChapter = true;
	let currentBook = null;
    export let id; 

	if (localStorage.jwt) {
		// Set auth token header auth
		const token = localStorage.jwt;
		const decoded = jwt_decode(token);
		const currentTime = Date.now() / 1000; // to get in milliseconds
		if (decoded.exp < currentTime && decoded) {
			store.dispatch(logoutUser());
			window.location.href = "/";
		}
	} else {
		window.location.href = "/";
	}

	const strapi = new Strapi(strapi_api);

	onMount(async () => {
		var data = await strapi.getEntry(
			"books",
			id
		);
		//console.log(data);
		let book = data[0];
		currentBook = id;
        
		chapters = book.chapters.sort(function(a,b){return a.number - b.number});;
		annotations = data[1];
		book_title = book.name;
		book_form = book.Form;
	});
	let annotations = {};
	let currentChapter = {};

	const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	// Desired file extesion
	const fileExtension = ".xlsx";

	export const exportToSpreadsheet = (data, fileName) => {
	//Create a new Work Sheet using the data stored in an Array of Arrays.
		const workSheet = XLSX.utils.aoa_to_sheet(data);
		// Generate a Work Book containing the above sheet.
		const workBook = {
			Sheets: { data: workSheet, cols: [] },
			SheetNames: ["data"],
		};
		// Exporting the file with the desired name and extension.
		const excelBuffer = XLSX.write(workBook, { bookType: "xlsx", type: "array" });
		const fileData = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(fileData, fileName + fileExtension);
	};


    async function renderChapter(event) {
		currentChapter = JSON.parse(event.target.closest('tr').getAttribute('chapter'));
		var chapterID = event.target.closest('tr').getAttribute('data');
		let chapter = await strapi.getEntry(
			"chapters",
			chapterID
		);
		for (let i = 0; i < chapter.versions.length; i++) {
			versions_list.push(chapter.versions[i]);
		}
		versions_list = versions_list.sort(function (a, b) {
			return a.version - b.version;
		});
		current_version = versions_list[0];
		chapterName = chapter.title;
		localStorage.setItem("currentBook", current_version.url);
		const queryString = current_version.url;
  		const urlParams = new URLSearchParams(queryString);
		if(current_version.url.includes('review-chapter.onelern.school')){
			localStorage.setItem("currentBook", urlParams.get('path'));	
		}
		localStorage.setItem("version", current_version.id);
		if(isRenderChapter){
			show = !show;
		}else{
			let annotations = await strapi.getEntries("annotations", {"uri": current_version.url, _limit: -1})
			//console.log(annotations)
			let exportData = [];
			exportData.push(["Sl. No", "Book", "Form", "Chapter Number" , "Chapter Name", "Highlighted Text", "Comment", "Reviewer Name", "Created At"]);
			//console.log(exportData)
			annotations.forEach((annotation,index) => {
				if(annotation.comments.length > 0){
					exportData.push([
						(index+1),
						book_title,
						book_form,
						currentChapter.number,
						currentChapter.title,
						annotation.quote,
						annotation.text,
						annotation.status,
						annotation.users_permissions_user.username,
						annotation.updatedAt,
						"",
						"",
						"",
						""
					]);
					annotation.comments.map((com)=>{
						exportData.push([
							(index+1),
							"",
							"",
							"",
							"",
							"",
							"",
							"",
							"",
							"",
							com.role,
							com.name.replace("%20"," "),
							com.text,
							com.published_at
						]);
					})
				}else{
					exportData.push([
						(index+1),
						book_title,
						book_form,
						currentChapter.number,
						currentChapter.title,
						annotation.quote,
						annotation.text,
						annotation.status,
						annotation.users_permissions_user.username,
						annotation.updatedAt,
						"",
						"",
						"",
						""
					]);
				}
			})
			//console.log(exportData)

			exportToSpreadsheet(exportData, book_title+"_"+currentChapter.title)

			isRenderChapter = true;
		}
	}

	async function exportContentFromRenderedChapter() {
		
		let annotations = await strapi.getEntries("annotations", {"uri": current_version.url, _limit: -1})
			//console.log(annotations)
			let exportData = [];
			exportData.push(["Sl. No", "Book", "Form", "Chapter Number" , "Chapter Name", "Highlighted Text", "Comment","Status", "Reviewer Name", "Created At", "Role", "Name", "Comment", "Published At"]);
			//console.log(exportData)
			annotations.forEach((annotation,index) => {
				if(annotation.comments.length > 0){
					exportData.push([
						(index+1),
						book_title,
						book_form,
						currentChapter.number,
						currentChapter.title,
						annotation.quote,
						annotation.text,
						annotation.status,
						annotation.users_permissions_user.username,
						annotation.updatedAt,
						"",
						"",
						"",
						""
					]);
					annotation.comments.map((com)=>{
						exportData.push([
							(index+1),
							"",
							"",
							"",
							"",
							"",
							"",
							"",
							"",
							"",
							com.role,
							com.name.replace("%20"," "),
							com.text,
							com.published_at
						]);
					})
				}else{
					exportData.push([
						(index+1),
						book_title,
						book_form,
						currentChapter.number,
						currentChapter.title,
						annotation.quote,
						annotation.text,
						annotation.status,
						annotation.users_permissions_user.username,
						annotation.updatedAt,
						"",
						"",
						"",
						""
					]);
				}
			})
			//console.log(exportData)

			exportToSpreadsheet(exportData, book_title+"_"+currentChapter.title)
	}

    async function updateBookOnCloseChapter(currentBook) {
		var data = await strapi.getEntry("books",currentBook);
		//console.log(data);
		show = !show;
		let book = data[0];
		versions_list = [];
		chapters = data[0].chapters.sort(function(a,b){ return a.number - b.number });
		annotations = data[1];
		book_title = book.name;
		book_form = book.Form;
	}

	function exportContent(event){
		isRenderChapter = false;
		currentChapter = JSON.parse(event.target.getAttribute("chapter"));
		console.log(currentChapter)
	}
		
</script>

<div class="container-fluid p-0 ">
	<SideNavBar activeClass="books" />

	<MainContent header={"Books"} bookname={book_title} form={book_form}>
		
			<div class="row">
				<div class="col">
					<div class="">
						<div class="card-body p-0 text-center">
							<div class="table-responsive">
								<table class="table chapters-table bg-white disable-td">
									<thead class="bg-light table-hr-bg">
										<tr>
											<th scope="col" class="border-0">Chapters</th>
											<th scope="col" class="border-0">All</th>
											{#if (localStorage.getItem('roleType') == "reviewer")}
												<th scope="col" class="border-0">Draft</th>
											{/if}
											<th scope="col" class="border-0">Open</th>
											<th scope="col" class="border-0">Fixed</th>
											<th scope="col" class="border-0">Approved</th>
											<th scope="col" class="border-0"/>
											<!-- <th scope="col" class="border-0">Export</th> -->
										</tr>
									</thead>
									<tbody>
										{#each chapters as chapter}
                                            <tr data={chapter.id} on:click={renderChapter} chapter={JSON.stringify(chapter)}>
                                                <td>{chapter.number}. {chapter.title}</td>
                                                {#if localStorage.getItem('roleType') == "reviewer" }
                                                    <td>{annotations[chapter.versions[0]] ? annotations[chapter.versions[0]].length : 0}</td>
                                                    <td>{annotations[chapter.versions[0]] ? annotations[chapter.versions[0]].filter(function (el) {return (el.status =="draft");}).length: 0}</td>
                                                {/if}
                                                {#if localStorage.getItem('roleType') == "author" }
                                                    <td>{annotations[chapter.versions[0]] ? annotations[chapter.versions[0]].filter(function (el) {return (el.status !="draft");}).length: 0}</td>
                                                {/if}
                                                
                                                <td>{annotations[chapter.versions[0]] ? annotations[chapter.versions[0]].filter(function (el) {return (el.status =="open");}).length: 0}</td>
                                                <td>{annotations[chapter.versions[0]] ? annotations[chapter.versions[0]].filter(function (el) {return (el.status =="fixed");}).length: 0}</td>
                                                <td>{annotations[chapter.versions[0]] ? annotations[chapter.versions[0]].filter(function (el) {return (el.status =="resolved");}).length: 0}</td>
                                                <td>
                                                    <button
                                                        class="next-icon"  
                                                    />
                                                </td>
												<!-- <td><button class="btn-export" on:click={exportContent} chapter={JSON.stringify(chapter)}>Export</button> </td> -->
                                            </tr>
                                        {/each}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
	</MainContent>
</div>
{#if show}
	<Modal bind:show>
		<div class="text-center">
			<div class="close-btn"  on:click={updateBookOnCloseChapter(currentBook)}>
				<span class="material-icons">
					arrow_back
				</span>
			</div>
			<div class="chapter-name">{chapterName}</div>
			{#if versions_list.length > 1}
				<a
					href={versions_list[versions_list.length - 1].url}
					class="fixed-version"
					target="_blank">See fixed version</a
				>
			{/if}

			{#if localStorage.getItem('roleType') == "author" }
				
				<button class="btn-export" on:click={exportContentFromRenderedChapter}> Download comments</button>
			{/if}

			{#if current_version}
				{#if current_version.url.includes('chapId=')}
				<iframe
				allowfullscreen
				enable-annotation
				title=""
				width="100%"
				src={current_version.url +
					"&strapiApi=" +
					window.localStorage.getItem("strapiApi") +
					"&uri=" +
					window.localStorage.getItem("currentBook") +
					"&userid=" +
					window.localStorage.getItem("userid") +
					"&username=" +
					window.localStorage.getItem("username") +
					"&token=" +
					window.localStorage.getItem("token") +
					"&roleType=" +
					window.localStorage.getItem("roleType") +
					"&version=" +
					window.localStorage.getItem("version") +
					"&title=" +
					window.localStorage.getItem("title")}
			/>
				{:else}
					<iframe
					allowfullscreen
					enable-annotation
					title=""
					width="100%"
					src={current_version.url +
						"?strapiApi=" +
						window.localStorage.getItem("strapiApi") +
						"&uri=" +
						window.localStorage.getItem("currentBook") +
						"&userid=" +
						window.localStorage.getItem("userid") +
						"&username=" +
						window.localStorage.getItem("username") +
						"&token=" +
						window.localStorage.getItem("token") +
						"&roleType=" +
						window.localStorage.getItem("roleType") +
						"&version=" +
						window.localStorage.getItem("version") +
						"&title=" +
						window.localStorage.getItem("title")}
				/>
				{/if}
				
			{/if}
		</div>
	</Modal>
{/if}

<style>
	iframe {
		height: calc(100vh - 60px);
		border: 3px solid #ecf0f4;
	}

	.close-btn {
		float: left;
		color: #414750;
		cursor: pointer;
		border-radius: 50%;
		margin: 21px 16px 16px 37px;
		font-size: 45px;
		line-height: 0;
	}
	.disable-td td {
		z-index: -1;
	}
	.disable-td tr {
		cursor: pointer;
	}
	.btn-export{
	border-radius: 1em;
	font-family: 'open_sauce_tworegular';
	font-size: 14px;
	color: #FFF !important;
	background: #4d3fff;
	padding: 5px 10px;
	cursor: pointer;
	float: right;
	margin: 16px 20px 0 0;
	border-radius: 16px;
}

	.btn-export:focus{
		outline: none;
	}

	
	
</style>
